/* eslint-disable no-template-curly-in-string */
export default {
    locale: 'fil-ph',
    Pagination: {
        items_per_page: 'Artikulo/Page',
        jump_to: 'Jump',
        jump_to_confirm: 'Determine',
        page: 'Pahinang',
        prev_page: 'Naunang Pahinan',
        next_page: 'Susunod na Pahinan',
        prev_5: '5 pahina pasusa',
        next_5: '5 pahina pabalik.',
        prev_3: '3 pahina patungo',
        next_3: '3 pahina pabalik',
        page_size: 'Pahinang',
    },
    DatePicker: {
        lang: {
            placeholder: 'Mangyaring pumili ng peksa',
            yearPlaceholder: 'Mangyaring pumili ng isang taon...',
            quarterPlaceholder: 'Mangyaring pumili ng quartere',
            monthPlaceholder: 'Mangyaring pumili ng isang buwan.',
            weekPlaceholder: 'Mangyaring pumili ng isang linggo.',
            rangePlaceholder: ['Date ng simulang', 'End Date'],
            rangeYearPlaceholder: ['Simula an', 'End Taon'],
            rangeMonthPlaceholder: ['Simula Buwana', 'End Month'],
            rangeWeekPlaceholder: ['Simula ng Linggon', 'End of Week'],
            locale: 'fil_PH',
            today: 'Ngayon...',
            now: 'Sa kasalukuyan',
            backToToday: 'Bumalik ngayon.',
            ok: 'Determine',
            timeSelect: 'Piliin ang oras',
            dateSelect: 'Piliit ang petsas',
            weekSelect: 'Pumili ng Linggon',
            clear: 'Lilinas',
            month: 'Buwana',
            year: 'Taong',
            previousMonth: 'Nakaraang buwan (turn page key)',
            nextMonth: 'Susunod na buwan (turn page down key)',
            monthSelect: 'Piliit ang Buka',
            yearSelect: 'Pumili ng Taan',
            decadeSelect: 'Magpili ng edada',
            yearFormat: 'YYYY Year',
            dayFormat: 'D-Day',
            dateFormat: 'YYYY Year M Month D Day',
            dateTimeFormat: 'YYYY Year M Month D Day HH Time mm Minutes ss Seconds',
            previousYear: 'Nakaraang taon (Control key plus left arrow key)',
            nextYear: 'Susunod na taon (Control key plus right arrow key)',
            previousDecade: 'Nakaraang Eras',
            nextDecade: 'Ang susunod na eras',
            previousCentury: 'Nakaraang siglo...',
            nextCentury: 'Ang susunod na siglo...',
        },
        timePickerLocale: {
            placeholder: 'Mangyaring pumili ng oras',
            rangePlaceholder: ['Simulan Oras', 'End Oras'],
        },
    },
    TimePicker: {
        placeholder: 'Mangyaring pumili ng oras',
        rangePlaceholder: ['Simulan Oras', 'End Oras'],
    },
    Calendar: {
        lang: {
            placeholder: 'Mangyaring pumili ng peksa',
            yearPlaceholder: 'Mangyaring pumili ng isang taon...',
            quarterPlaceholder: 'Mangyaring pumili ng quartere',
            monthPlaceholder: 'Mangyaring pumili ng isang buwan.',
            weekPlaceholder: 'Mangyaring pumili ng isang linggo.',
            rangePlaceholder: ['Date ng simulang', 'End Date'],
            rangeYearPlaceholder: ['Simula an', 'End Taon'],
            rangeMonthPlaceholder: ['Simula Buwana', 'End Month'],
            rangeWeekPlaceholder: ['Simula ng Linggon', 'End of Week'],
            locale: 'fil_PH',
            today: 'Ngayon...',
            now: 'Sa kasalukuyan',
            backToToday: 'Bumalik ngayon.',
            ok: 'Determine',
            timeSelect: 'Piliin ang oras',
            dateSelect: 'Piliit ang petsas',
            weekSelect: 'Pumili ng Linggon',
            clear: 'Lilinas',
            month: 'Buwana',
            year: 'Taong',
            previousMonth: 'Nakaraang buwan (turn page key)',
            nextMonth: 'Susunod na buwan (turn page down key)',
            monthSelect: 'Piliit ang Buka',
            yearSelect: 'Pumili ng Taan',
            decadeSelect: 'Magpili ng edada',
            yearFormat: 'YYYY Year',
            dayFormat: 'D-Day',
            dateFormat: 'YYYY Year M Month D Day',
            dateTimeFormat: 'YYYY Year M Month D Day HH Time mm Minutes ss Seconds',
            previousYear: 'Nakaraang taon (Control key plus left arrow key)',
            nextYear: 'Susunod na taon (Control key plus right arrow key)',
            previousDecade: 'Nakaraang Eras',
            nextDecade: 'Ang susunod na eras',
            previousCentury: 'Nakaraang siglo...',
            nextCentury: 'Ang susunod na siglo...',
        },
        timePickerLocale: {
            placeholder: 'Mangyaring pumili ng oras',
            rangePlaceholder: ['Simulan Oras', 'End Oras'],
        },
    },
    global: { placeholder: 'Pakipilin' },
    Table: {
        filterTitle: 'Filtral',
        filterConfirm: 'Determine',
        filterReset: 'Reseta',
        filterEmptyText: 'Walang filter item',
        selectAll: 'Pumili ang lahat ng pahinan',
        selectInvert: 'Reverte na Pagpilin',
        selectNone: 'Laman ang Lahta',
        selectionAll: 'Piliit ang Lahat',
        sortTitle: 'Sort',
        expand: 'Lawak ng Row',
        collapse: 'Isara ng Row',
        triggerDesc: 'Click Descendingd',
        triggerAsc: 'Click Ascending',
        cancelSort: 'Unsorte',
    },
    Modal: { okText: 'Determine', cancelText: 'Kansela', justOkText: 'Alam ko.' },
    Popconfirm: { cancelText: 'Kansela', okText: 'Determine' },
    Transfer: {
        searchPlaceholder: 'Mangyaring ipasok ang nilalaman ng paghahanap',
        itemUnit: 'Itema',
        itemsUnit: 'Itema',
        remove: 'Mangalisa',
        selectCurrent: 'Pumili ang lahat ng pahinan',
        removeCurrent: 'Tanggal ang kasalukuyang pahinan',
        selectAll: 'Piliit ang Lahat',
        removeAll: 'Ang Lahta',
        selectInvert: 'Reverte na Pagpilin',
    },
    Upload: {
        uploading: 'Pag-upload ng files',
        removeFile: 'Tanggal ang files',
        uploadError: 'Error a uploads',
        previewFile: 'Preview files',
        downloadFile: 'Download ang Files',
    },
    Empty: { description: 'Walang datas' },
    Icon: { icon: 'Mga icon' },
    Text: {
        edit: 'Pag-edita',
        copy: 'Kopyahay',
        copied: 'Pagkopya ng tagumpa',
        expand: 'Lawak',
    },
    PageHeader: { back: 'Bumalik' },
    Form: {
        optional: '(Opsyonal)',
        defaultValidateMessages: {
            default: 'Error ang patlang na Validation ${label}',
            required: 'Mangyaring ipasok ang ${label}',
            enum: '${label} ay dapat isa sa [${enum}]',
            whitespace: '${label} hindi maaaring maging null character',
            date: {
                format: '${label} Hindi maliit na format ng peta',
                parse: '${label} ay hindi maaaring maging date',
                invalid: '${label} ay hindi tanggap',
            },
            types: {
                string: '${label} ay hindi saligang ${type}',
                method: '${label} ay hindi saligang ${type}',
                array: '${label} ay hindi saligang ${type}',
                object: '${label} ay hindi saligang ${type}',
                number: '${label} ay hindi saligang ${type}',
                date: '${label} ay hindi saligang ${type}',
                boolean: '${label} ay hindi saligang ${type}',
                integer: '${label} ay hindi saligang ${type}',
                float: '${label} ay hindi saligang ${type}',
                regexp: '${label} ay hindi saligang ${type}',
                email: '${label} ay hindi saligang ${type}',
                url: '${label} ay hindi saligang ${type}',
                hex: '${label} ay hindi saligang ${type}',
            },
            string: {
                len: '${label} ay ${len} characters',
                min: '${label} minimum ${min} characters',
                max: '${label} hanggang ${max} characters',
                range: '${label} ay dapat sa pagitan ng ${min}-${max} characters',
            },
            number: {
                len: '${label} ay dapat katumbas ng ${len}',
                min: 'Ang pinakamababang halaga ng ${label} ay ${min}',
                max: 'Ang pinakamataas na halaga ng ${label} ay ${max}',
                range: '${label} ay dapat sa pagitan ng ${min}-${max}',
            },
            array: {
                len: 'Dapat na ${len} ${label}',
                min: 'Minimum ${min} ${label}',
                max: 'Hanggang ${max} ${label}',
                range: '${label} ay dapat sa pagitan ng ${min} at ${max}',
            },
            pattern: {
                mismatch: '${label} ay hindi tumutugma sa pattern ${pattern}',
            },
        },
    },
    Image: { preview: 'Preview a' },
};
